import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Grid, { GridSpacing } from '@material-ui/core/Grid';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import Radio, { RadioProps } from '@material-ui/core/Radio';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';

const buttonStyle = {
  maxWidth: '180px',
  maxHeight: '35px',
  minWidth: '180px',
  minHeight: '35px',
  marginBottom: '8px',
};
const useStyles = makeStyles(
  createStyles({
    tableHeader: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      borderCollapse: `collapse`,
    },
    tableTd: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      padding: '0px',
    },
    colTime: {
      textAlign: 'center',
    },
  })
);

type Props = {
  onClickSaveButton: () => void;
  onClickCancelButton: () => void;
};

const ItemRegistFooter: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <Grid container justify="flex-start" spacing={1} direction="row" alignItems="center" style={{ width: 'calc(100vw - 12px)'}}>
      <Grid item xs={2}>
        <Button
          style={buttonStyle}
          variant="contained"
          color="primary"
          disableElevation
          onClick={(e) =>{
            props.onClickSaveButton()
          }}
        >
          {t('ItemRegistFooter.保存','保存')}
        </Button>
      </Grid>
      <Grid item xs={2}>
        <Button
          style={buttonStyle}
          variant="contained"
          color="primary"
          disableElevation
          onClick={(e) => props.onClickCancelButton()}
        >
          {t('ItemRegistFooter.中止','中止')}
        </Button>
      </Grid>
    </Grid>
  );
};

export default ItemRegistFooter;
